<template>
    <div>
      <b-modal v-if="first" header-bg-variant="primary" header-text-variant="white" size="xl" id="modal-first" visible centered ok-disabled title="Поздравляем с регистрацией!">
        <div class="row">
          <div class="col-md-12">
            <p>Здравствуйте!</p>
            <p>Большое спасибо, что решили воспользоваться сервисом расчета заработной платы.</p>
              <!--<p>В ознакомительных целях вам на сутки предоставлен полный доступ к функционалу. После ознакомительного периода вы также можете пользоваться калькулятором, но для остального функционала нужно будет оформить подписку.</p>-->
            <p>Информацию о расценках и способах оплаты вы можете найти по <b-link to="/info/price" target="_blank">этой ссылке</b-link></p>
            <p>В калькуляторе есть ссылка на краткую <a href="https://youtu.be/GmZB8JyFjX4" target="_blank">видеоинструкцию</a>, которая объясняет, как пользоваться сервисом.</p>
            <p>Всего хорошего!</p>
          </div>
        </div>
        <template v-slot:modal-footer="{cancel}">
          <b-button variant="secondary" size="sm" @click="cancel()"><span class="mdi mdi-close"></span> Закрыть
          </b-button>
        </template>
      </b-modal>

      <div v-if="user.registered">
          <b-modal header-bg-variant="primary" header-text-variant="white" size="xl" id="modal-profile" centered ok-disabled title="Профиль пользователя"
                   cancel-title-html="Закрыть" button-size="sm">

            <div class="row">
              <div class="col-md-5">
                <h5>Данные пользователя</h5>

                <div class="form-group">
                  <label for="culsKzProfilePhone">Логин *</label>
                  <b-form-input id="culsKzProfilePhone" type="text" size="sm" v-mask="'+7 (###) ###-##-##'" v-model="user.phone"
                                placeholder="+7 (___) ___-__-__"></b-form-input>
                  <small class="form-text text-muted">Ваш номер телефона (логин)</small>
                  <small class="form-text text-error">Будьте внимательны при изменении номера телефона! Если вы укажете некорректные данные, вы можете потерять доступ к своей учетной записи.</small>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="culsKzProfileName">Имя *</label>
                      <b-form-input id="culsKzProfileName" type="text" size="sm" v-model="user.name"></b-form-input>
                      <small class="form-text text-muted">Ваше имя, фамилия</small>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="culsKzProfileEmail">Email *</label>
                      <b-form-input id="culsKzProfileEmail" type="email" size="sm" v-model="user.email"></b-form-input>
                      <small class="form-text text-muted">Ваш адрес электронной почты</small>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <hr>
                    Данные ниже заполняется только если вы хотите изменить ваш действующий пароль.
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="culsKzProfilePassword">Пароль</label>
                      <b-form-input id="culsKzProfilePassword" type="password" size="sm" v-model="user.password"></b-form-input>
                      <small class="form-text text-muted">Новый пароль</small>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="culsKzProfilePassword">Пароль еще раз</label>
                      <b-form-input id="culsKzProfilePassword2" type="password" size="sm" v-model="user.password2"></b-form-input>
                      <small class="form-text text-muted">Повторите новый пароль</small>
                    </div>
                  </div>
                </div>




              </div>
              <div class="col-md-4">
                <h5>Подписка</h5>
                <table class="table table-sm table-striped table-bordered table-12">
                  <tbody>
                  <tr>
                    <th>№</th>
                    <th>Дата</th>
                    <th>Подписка с</th>
                    <th>Подписка по</th>
                  </tr>
                  <template v-for="(item, index) in user.subscribes">
                    <tr :key="index">
                      <td>{{index + 1}}</td>
                      <td>{{item.date}}</td>
                      <td>{{item.date_salary_from}}</td>
                      <td>{{item.date_salary_to}}</td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>
              <div class="col-md-3">
                <h5>Оплата</h5>
                <table class="table table-sm table-striped table-bordered table-12">
                  <tbody>
                  <tr>
                    <th>№</th>
                    <th>Дата</th>
                    <th>Сумма</th>
                  </tr>
                  <template v-for="(item, index) in user.billing">
                    <tr :key="index">
                      <td>{{index + 1}}</td>
                      <td>{{item.date}}</td>
                      <td>{{item.amount}}</td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>
            </div>
            <template v-slot:modal-footer="{cancel}">
              <b-button variant="primary" size="sm" @click="doAuth('save-profile')"><span
                  class="mdi mdi-content-save"></span> Сохранить изменения
              </b-button>
              <b-button variant="secondary" size="sm" @click="cancel()"><span class="mdi mdi-close"></span> Закрыть
              </b-button>
            </template>

          </b-modal>


          <b-button class="mr-sm-1" variant="light" size="sm"  @click="doAuth('signout')"><span class="mdi mdi-logout"></span>
                Выйти
            </b-button>
            <b-button variant="outline-light" size="sm" @click="doAuth('profile')"><span class="mdi mdi-cog"></span> {{ 'Профиль ' + user.profilename}}</b-button>
        </div>

        <div v-else>
          <!-- Форма восстановления -->
          <b-modal header-bg-variant="primary" header-text-variant="white" size="sm" id="modal-recovery" centered ok-disabled title="Восстановление пароля"
                     cancel-title-html="Закрыть" button-size="sm">

                <div>
                    <div class="form-group">
                        <label for="">Логин</label>
                        <b-form-input id="culsKzAuthRecoveryUserPhone" type="text" size="sm" v-mask="'+7 (###) ###-##-##'" v-model="recovery.user.phone"
                                      placeholder="+7 (___) ___-__-__" :readonly="recovery.button"></b-form-input>
                        <small v-if="!recovery.button" class="form-text text-muted">Введите ваш номер телефона, доступ к которому вы хотите
                            восстановить. Вы получите код восстановления на Email, который вы указали при регистрации вашего аккаунта</small>
                    </div>

                    <div v-if="!recovery.button" class="form-group text-center">
                        <b-button variant="success" size="sm" @click="doAuth('code')">Получить код</b-button>
                    </div>
                </div>

                <div v-if="recovery.button">
                    <div class="form-group">
                        <label for="">Код</label>
                        <b-form-input id="culsKzAuthRecoveryCode" type="text" size="sm" v-mask="'######'" v-model="recovery.user.code"></b-form-input>
                        <small class="form-text text-muted">Введите код, который вы получили по Email</small>
                    </div>

                    <div class="form-group">
                        <label for="">Новый пароль</label>
                        <b-form-input id="culsKzAuthRecoveryNewPassword1" type="password" size="sm" v-model="recovery.user.password"></b-form-input>
                        <small class="form-text text-muted">Введите новый пароль</small>
                    </div>

                    <div class="form-group">
                        <label for="">Пароль еще раз</label>
                        <b-form-input id="culsKzAuthRecoveryNewPassword2" type="password" size="sm" v-model="recovery.user.password2"></b-form-input>
                        <small class="form-text text-muted">Повторите новый пароль</small>
                    </div>

                </div>


                <template v-slot:modal-footer="{cancel}">
                    <b-button variant="primary" size="sm" @click="doAuth('recovery')" :disabled="!recovery.button"><span
                        class="mdi mdi-key"></span> Восстановить пароль
                    </b-button>
                    <b-button variant="secondary" size="sm" @click="cancel()"><span class="mdi mdi-close"></span> Закрыть
                    </b-button>
                </template>
            </b-modal>

          <!-- Форма входа -->
          <b-modal header-bg-variant="primary" header-text-variant="white" size="sm" id="modal-signin" centered ok-disabled title="Авторизация" cancel-title-html="Закрыть"
                     button-size="sm">
                <div v-if="user.message" class="alert alert-success text-center">Теперь вы можете войти под своей
                    учетной записью
                </div>
                <div class="form-group">
                    <label for="">Логин</label>
                    <b-form-input id="culsKzAuthSignInUserPhone" type="text" size="sm" v-mask="'+7 (###) ###-##-##'" v-model="user.phone"
                                  placeholder="+7 (___) ___-__-__"></b-form-input>
                    <small class="form-text text-muted">Введите ваш номер телефона, который вы использовали при
                        регистрации</small>
                </div>

                <div class="form-group">
                    <label for="">Пароль</label>
                    <b-form-input id="culsKzAuthSignInUserPassword" type="password" size="sm" v-model="user.password"></b-form-input>
                    <small class="form-text text-muted">Введите ваш пароль</small>
                </div>

            <b-form-group>
              <b-form-checkbox size="sm" value="1" unchecked-value="0" v-model="user.usesecret">Запомнить меня на этом компьютере и входить в калькулятор автоматически</b-form-checkbox>
            </b-form-group>

                <p class="text-center">Забыли пароль? <a v-b-modal.modal-recovery
                                                         @click="doRecovery()"
                                                         href="#">Восстановить</a></p>
                <template v-slot:modal-footer="{cancel}">
                    <b-button variant="primary" size="sm" @click="doAuth('signin')"><span class="mdi mdi-login"></span>
                        Авторизация
                    </b-button>
                    <b-button variant="secondary" size="sm" @click="cancel()"><span class="mdi mdi-close"></span> Закрыть
                    </b-button>
                </template>
          </b-modal>

          <!-- Форма регистрации -->
          <b-modal header-bg-variant="primary" header-text-variant="white" size="lg" id="modal-signup" centered ok-disabled title="Регистрация" cancel-title-html="Закрыть"
                     button-size="sm">
                <div class="row">
                    <div class="col-md-12">
                        <p class="text-danger">Внимание! Все поля обязательны для заполнения</p>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">Мобильный телефон</label>
                            <b-form-input id="culsKzAuthSignUpUserPhone" type="text" size="sm" v-mask="'+7 (###) ###-##-##'" v-model="user.regphone"
                                          placeholder="+7 (___) ___-__-__"></b-form-input>
                            <small class="form-text text-muted">Будет использоваться как логин для входа на сайт</small>
                        </div>

                        <div class="form-group">
                            <label for="">Имя, Фамилия</label>
                            <b-form-input id="culsKzAuthSignUpName" type="text" size="sm" v-model="user.regname"
                                          placeholder="Ваше имя"></b-form-input>
                            <small class="form-text text-muted">Введите ваше имя</small>
                        </div>

                        <div class="form-group">
                            <label for="">Email</label>
                            <b-form-input id="culsKzAuthSignUpEmail" type="email" size="sm" v-model="user.regemail"></b-form-input>
                            <small class="form-text text-muted">Введите адрес электронной почты. Указывайте реальный Email, так как он будет необходим для получения уведомлений и восстановления доступа к аккаунту.</small>
                        </div>

                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">Пароль</label>
                            <b-form-input id="culsKzAuthSignUpPassword1" type="password" size="sm" v-model="user.regpassword"></b-form-input>
                            <small class="form-text text-muted">Придумайте пароль для входа на сайт</small>
                        </div>
                        <div class="form-group">
                            <label for="">Пароль еще раз</label>
                            <b-form-input id="culsKzAuthSignUpPassword2" type="password" size="sm" v-model="user.regpassword2"></b-form-input>
                            <small class="form-text text-muted">Повторите ввод пароля</small>
                        </div>
                        <div class="form-group">
                            <b-form-checkbox id="culsKzAuthSignUpAgreement" v-model="user.regagreement" value="1" unchecked-value="0">Регистрируясь, я
                                соглашаюсь с условиями <a href="https://dsb.kz/agreement/" target="_blank">пользовательского
                                    соглашения</a>, <a href="https://dsb.kz/disclaimer" target="_blank">отказа от ответственности и политики конфиденциальности</a></b-form-checkbox>
                        </div>

                    </div>
                </div>
                <template v-slot:modal-footer="{cancel}">
                    <b-button variant="primary" size="sm" @click="doAuth('signup')"><span class="mdi mdi-account"></span>
                        Зарегистрироваться
                    </b-button>
                    <b-button variant="secondary" size="sm" @click="cancel()"><span class="mdi mdi-close"></span> Закрыть
                    </b-button>
                </template>
            </b-modal>

            <b-button class="mr-sm-1" v-b-modal.modal-signin variant="light" size="sm"><span class="mdi mdi-login"></span>
              Войти
            </b-button>
            <b-button v-b-modal.modal-signup variant="outline-light" size="sm"><span class="mdi mdi-account-plus"></span>
              Регистрация
            </b-button>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: 'Authentication',
    props: [],
    data: function () {
        return {
            recovery: {
                button: false,
              user: {
                phone: '',
                code: '',
                password: '',
                password2: ''
              }
            },
            first: false
        }
    },
    methods: {
      doRecovery: function () {
        // Инициализация окна восстановления пароля
        this.recovery.user.phone = '';
        this.recovery.user.code = '';
        this.recovery.user.password = '';
        this.recovery.user.password2 = '';
        this.recovery.button = false;
        this.$bvModal.hide('modal-signin');
      },
        doAuth: function (mode) {
            this.$store.commit('wait', {state: true, name: 'Модуль авторизации'});
            this.$http
                .post(this.$apiold, {
                    task: 'auth',
                    mode: mode,
                    user: this.user,
                    recovery_user: this.recovery.user,
                })
                .then(response => {

                    if (mode == 'signin' && response.data.first) {
                        this.first = true
                    }
                    else {
                        this.first = false
                    }

                    this.$store.commit('wait', {state: false});
                    this.$store.commit('user', response.data.user);
                    this.$store.commit('change');

                    // Поле ввода кода
                    this.recovery.button = response.data.recovery;

                    // Сообщения
                    this.$store.commit('alert', response.data.messages);

                    if (response.data.modal_signin) {
                        this.$bvModal.show('modal-signin');
                    } else {
                        this.$bvModal.hide('modal-signin');
                    }




                    if (response.data.modal_signup) {
                        this.$bvModal.show('modal-signup');
                    } else {
                        this.$bvModal.hide('modal-signup');
                    }

                    if (response.data.modal_recovery) {
                        this.$bvModal.show('modal-recovery');
                    } else {
                        this.$bvModal.hide('modal-recovery');
                    }
                  if (response.data.modal_profile) {
                    this.$bvModal.show('modal-profile');
                  } else {
                    this.$bvModal.hide('modal-profile');
                  }
                  if (this.user.registered) {
                    this.setOrgs();
                  }
                });

        }
    },
    created: function () {
       this.doAuth('init');
    },

    computed: {
      ...mapGetters({
        user: 'user'
      })
    },
    watch: {
        user() {
            if (!this.user.registered) {
                // this.$bvModal.show('modal-auth');
            }
        }
    }
}
</script>

<style>

</style>
